import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import HuntmasterDashboard from './components/HuntmasterDashboard';
import './App.css';

const AppContent: React.FC = () => {
  const { state } = useAuth();
  
  if (!state.isAuthenticated) {
    return (
      <div className="app">
        <Login />
      </div>
    );
  }

  // Render huntmaster dashboard if user is huntmaster
  if (state.group?.isHuntmaster) {
    return (
      <div className="app">
        <HuntmasterDashboard />
      </div>
    );
  }

  // Render regular team dashboard
  return (
    <div className="app">
      <Dashboard />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
